import Vue from 'vue';
import * as firebase from 'firebase/app';

// init
if (!firebase.apps.length) {
	firebase.initializeApp({
		apiKey: 'AIzaSyCDI5O4f8v0bQVAMeaNeTamLvKS9F4-vr0',
		authDomain: 'cambridge-872b6.firebaseapp.com',
		databaseURL: 'https://cambridge-872b6.firebaseio.com',
		projectId: 'cambridge-872b6',
		storageBucket: 'cambridge-872b6.appspot.com',
		messagingSenderId: '450832994959',
		appId: '1:450832994959:web:b5f4ae1ef95552a62116fa',
		measurementId: 'G-BEYNS77PCM'
	});
}
import 'firebase/auth';
import 'firebase/firestore';
import VueFire from 'vuefire';

firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

// vuefire
Vue.use(VueFire);
export default firebase;
export const db = firebase.firestore();
